import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';

interface ErrorStateProps {
  onRetry: () => void;
}

export const ErrorState = ({ onRetry }: ErrorStateProps) => {
  const { t } = useTranslation('drivers');
  return (
    <div className='flex min-h-[400px] flex-col items-center justify-center gap-3 text-center'>
      <Icon name='triangle-alert' size='lg' color='danger' />
      <Typography variant='text-md-semibold'>{t('face_id.selector.error.title')}</Typography>
      <Button type='button' variant='outlined' size='sm' onClick={onRetry}>
        {t('face_id.selector.error.retry')}
      </Button>
    </div>
  );
};

export default ErrorState;
